// AddComboPopup.js
import React, { useState, useMemo } from "react";
import axios from "axios";
import config from "../../config";
import AddIcon from "@mui/icons-material/Add";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";

function AddComboPopup({ onClose, services }) {
  const [comboName, setComboName] = useState("");
  const [comboServices, setComboServices] = useState([
    { service: null },
    { service: null }
  ]);
  const [comboPrice, setComboPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [duration, setDuration] = useState("");

  // Flatten all services from all categories and exclude combos
  const allIndividualServices = useMemo(() => {
    const flattenedServices = [];
    
    services.forEach(category => {
      // Add services from the 'services' array
      if (category.services && Array.isArray(category.services)) {
        category.services.forEach(service => {
          flattenedServices.push({
            ...service,
            categoryName: category.category_name
          });
        });
      }
      
      // Exclude services from the 'combos' array (don't include combos)
    });
    
    return flattenedServices;
  }, [services]);

  const handleServiceChange = (index, value) => {
    const updatedServices = [...comboServices];
    // Find the complete service object from the flattened services list
    const selectedService = allIndividualServices.find(service => service.id.toString() === value);
    updatedServices[index].service = selectedService;
    setComboServices(updatedServices);
  };

  const addServiceField = () => {
    setComboServices([...comboServices, { service: null }]);
  };

  console.log("allIndividualServices", allIndividualServices);

  const removeServiceField = (index) => {
    if (comboServices.length > 2) {
      const updatedServices = [...comboServices];
      updatedServices.splice(index, 1);
      setComboServices(updatedServices);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const token = localStorage.getItem("token");
      const branchId = localStorage.getItem("branch_id");
      
      // Prepare services data with full service objects
      const servicesData = comboServices
        .filter(item => item.service !== null)
        .map(item => item.service);
      
      const comboData = {
        combo_name: comboName,
        services: servicesData, 
        combo_price: comboPrice,
        duration: duration
      };

      const response = await axios.post(
        `${config.apiUrl}/api/swalook/combo/?branch_name=${branchId}`,
        comboData,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        toast.success("Combo created successfully!");
        onClose();
      }
    } catch (error) {
      console.error("Error creating combo:", error);
      toast.error("Failed to create combo. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-700 mb-4">Create New Combo</h2>
          <button className="text-red-500 hover:text-red-700" onClick={onClose}>
            <FontAwesomeIcon icon={faTimesCircle} className="text-3xl" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Combo Name
            </label>
            <input
              type="text"
              className="border border-gray-300 rounded-md w-full px-3 py-2"
              value={comboName}
              onChange={(e) => setComboName(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Services in Combo
            </label>
            
            {comboServices.map((serviceObj, index) => (
              <div key={index} className="flex items-center mb-2">
                <select
                  className="border border-gray-300 rounded-md px-3 py-2 mr-2 flex-1"
                  value={serviceObj.service ? serviceObj.service.id : ""}
                  onChange={(e) => handleServiceChange(index, e.target.value)}
                  required
                >
                  <option value="">Select Service</option>
                  {allIndividualServices.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.service} (Rs.{s.service_price}) - {s.categoryName}
                    </option>
                  ))}
                </select>
                
                {comboServices.length > 2 && (
                  <button
                    type="button"
                    className="bg-red-500 text-white px-2 py-1 rounded-md text-sm"
                    onClick={() => removeServiceField(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            
            <button
              type="button"
              className="flex items-center text-indigo-500 mt-2 text-sm"
              onClick={addServiceField}
            >
              <AddIcon className="mr-1" /> Add Another Service
            </button>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Combo Price
            </label>
            <input
              type="number"
              className="border border-gray-300 rounded-md w-full px-3 py-2"
              value={comboPrice}
              onChange={(e) => setComboPrice(e.target.value)}
              min="0"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Duration (minutes)
            </label>
            <input
              type="number"
              className="border border-gray-300 rounded-md w-full px-3 py-2"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              min="1"
              required
            />
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Combo"}
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
}

export default AddComboPopup;